import xldImage from './xld-image.vue';

export default {
  install(Vue) {
    Vue.component('XldImage', xldImage);
  }
};
